// extracted by mini-css-extract-plugin
export default {"productsHeader":"styles_productsHeader__byAOh"};